export class IdentifiableDto {
    id: string;
}